/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_6_QInputs */

const en_mk_faq_6_q = /** @type {(inputs: Mk_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which agents and AI services can I use?`)
};

const id_mk_faq_6_q = /** @type {(inputs: Mk_Faq_6_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent dan layanan AI apa yang bisa dipakai?`)
};

/**
* | output |
* | --- |
* | "Which agents and AI services can I use?" |
*
* @param {Mk_Faq_6_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_6_q = /** @type {((inputs?: Mk_Faq_6_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_6_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_6_q(inputs)
	return en_mk_faq_6_q(inputs)
});